/* TODO replace render functions with components */
/* eslint-disable react/jsx-no-bind */
import React from 'react';

import Aside from 'atoms/Aside';
import ConditionalRenderer from 'atoms/ConditionalRenderer';

import { EditorialBannerRight } from 'molecules/EditorialBanners';

import YandexBlock from './YandexBlock';

import type { FC, ReactNode } from 'react';

interface Props {
    staticTopContent: ReactNode;
    stickyBottomContent: ReactNode;
}

const HomeAside: FC<Props> = ({ staticTopContent, stickyBottomContent }) => (
    <ConditionalRenderer ifDesktop>
        <Aside>
            <Aside.Static>
                {staticTopContent}
                <YandexBlock
                    key="aside-vkp"
                    id="R-A-17421134-9"
                />
            </Aside.Static>
            <Aside.Sticky>
                <EditorialBannerRight />
                {stickyBottomContent}
            </Aside.Sticky>
        </Aside>
    </ConditionalRenderer>
);

export default HomeAside;
